import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';

import {
  BdPermissionsTableComponent,
  PermissionEntry,
} from './permissions-table.component';

export interface PermissionsDialogData {
  shareableType: ShareableType;
  shareableId: string;
  onDetail?: (payload: {
    entry: PermissionEntry;
    resolvedName: string;
  }) => void;
}

@Component({
  selector: 'bd-permissions-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <bd-permissions-table
      [shareableType]="data.shareableType"
      [shareableId]="data.shareableId"
      (detailRequested)="onDetail($event)"
    ></bd-permissions-table>
  `,
  imports: [BdPermissionsTableComponent],
})
export class BdPermissionsDialogComponent {
  private readonly _config =
    inject<DynamicDialogConfig<PermissionsDialogData>>(DynamicDialogConfig);

  public readonly data = this._requireData();

  private _requireData(): PermissionsDialogData {
    if (!this._config.data) {
      throw new Error('BdPermissionsDialogComponent requires dialog data');
    }
    return this._config.data;
  }

  public onDetail(payload: {
    entry: PermissionEntry;
    resolvedName: string;
  }): void {
    this.data.onDetail?.(payload);
  }
}
